export const getBalanceString = (balance, currency) => {
  const balanceString =
    "$" +
    balance.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) +
    " " +
    currency;
  return balanceString;
};

export const getAbsoluteBalanceString = (balance, currency) => {
  if (!balance) {
    return "N/A";
  }

  const balanceString =
    balance >= 0
      ? "$" +
        balance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        " " +
        currency
      : "$" +
        (balance * -1).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        " " +
        currency;
  return balanceString;
};

export const capitalizeFirstLetters = (string) => {
  const words = string.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }
  return words.join(" ");
};
